/**
 * © 2025. The EGT Universe. All Rights Reserved.
 * License: Requires ACTIVE AppArtisan Subscription.
 * For mor information visit: https://egtuniverse.com/legal
 * 
 * Manages fields, a replacement for JSON Schema.
 * 
 * Created by Justin K Kazmierczak.
 */
var _ = require("../uam/fields.module.js")(module.exports, {
    namespace: "noattr.string",
    title: "String (No Attributes)",
    description: "Raw string type for schema validation (no attributes).",
    type: "field",
    use: {
        namespace: "ua.input"
    },
    tests: {
        validString: {
            must: true,
            run: function () {
                return validate({ title: "Test", type: "string" }, "hello");
            }
        },
        invalidNumber: {
            throw: "fields.noattr.string.invalid",
            run: function () {
                return validate({ title: "Test", type: "string" }, 123);
            }
        }
    },
    errors: {
        invalid: {
            title: "Invalid String",
            description: "The value must be a string.",
            template: "Expected a string but received ${typeof}"
        }
    }
});

function validate(spec, data) {
    if (typeof data !== "string") {
        _.errors.invalid.throw({ typeof: typeof data });
    }
}
module.exports.validate = validate;
